import { AssetClassHistoricalReturns } from 'types/historical-returns';

export const historicalReturnsData: AssetClassHistoricalReturns = {
	stocks: {
		name: 'Stocks',
		annualReturns: [
			{
                year: 1978,
                annualReturn: 6.56
              },
              {
                 year: 1979,
                annualReturn: 18.44
              },
              {
                 year: 1980,
                annualReturn: 32.42
              },
              {
                 year: 1981,
                annualReturn: -4.91
              },
              {
                 year: 1982,
                annualReturn: 21.55
              },
              {
                 year: 1983,
                annualReturn: 22.56
              },
              {
                 year: 1984,
                annualReturn: 6.27
              },
              {
                 year: 1985,
                annualReturn: 31.73
              },
              {
                 year: 1986,
                 annualReturn: 18.67
              },
              {
                year: 1987,
                annualReturn: 5.25
              },
              {
                year: 1988,
                annualReturn: 16.61
              },
              {
                year: 1989,
                annualReturn: 31.69
              },
              {
                year: 1990,
                annualReturn: -3.10
              },
              {
                year: 1991,
                annualReturn: 30.47
              },
              {
                 year: 1992,
                annualReturn: 7.62
              },
              {
                 year: 1993,
                annualReturn: 10.08
              },
              {
                 year: 1994,
                  annualReturn: 1.32
              },
              {
                 year: 1995,
                  annualReturn: 37.58
              },
              {
                 year: 1996,
                  annualReturn: 22.96
              },
              {
                 year: 1997,
                  annualReturn: 33.36
              },
              {
                 year: 1998,
                  annualReturn: 28.58
              },
              {
                 year: 1999,
                  annualReturn: 21.04
              },
              {
                 year: 2000,
                  annualReturn: -9.10
              },
              {
                 year: 2001,
                  annualReturn: -11.89
              },
              {
                 year: 2002,
                  annualReturn: -22.10
              },
              {
                 year: 2003,
                  annualReturn: 28.68
              },
              {
                 year: 2004,
                  annualReturn: 10.88
              },
              {
                 year: 2005,
                  annualReturn: 4.91
              },
              {
                 year: 2006,
                  annualReturn: 15.79
              },
              {
                 year: 2007,
                  annualReturn: 5.49
              },
              {
                 year: 2008,
                  annualReturn: -37.00
              },
              {
                 year: 2009,
                  annualReturn: 26.46
              },
              {
                 year: 2010,
                  annualReturn: 15.06
              },
              {
                 year: 2011,
                  annualReturn: 2.11
              },
              {
                 year: 2012,
                  annualReturn: 16.00
              },
              {
                 year: 2013,
                  annualReturn: 32.39
              },
              {
                 year: 2014,
                  annualReturn: 13.69
              },
              {
                 year: 2015,
                  annualReturn: 1.38
              },
              {
                 year: 2016,
                  annualReturn: 11.96
              },
              {
                 year: 2017,
                  annualReturn: 21.83
              },
              {
                 year: 2018,
                  annualReturn: -4.38
              },
              {
                 year: 2019,
                  annualReturn: 31.49
              }
		],
		historicalAverages: [
			{
				trailingYears: 1,
				totalReturn: {
					avgAnnualReturn: null,
					stdDev: null
				},
				incomeReturn: {
					avgAnnualIncome: 0.0183,
					stdDev: null
				}
			},
			{
				trailingYears: 5,
				totalReturn: {
					avgAnnualReturn: 0.1139,
					stdDev: 0.1463,
					sharpeRatio: 0.66
				},
				incomeReturn: {
					avgAnnualIncome: 0.0198,
					stdDev: null
				}
			},
			{
				trailingYears: 10,
				totalReturn: {
					avgAnnualReturn: 0.1198,
					stdDev: 0.1226,
					sharpeRatio: 0.81
				},
				incomeReturn: {
					avgAnnualIncome: 0.0199,
					stdDev: 0.0014
				}
			},
			{
				trailingYears: 20,
				totalReturn: {
					avgAnnualReturn: 0.0656,
					stdDev: 0.1807,
					sharpeRatio: 0.22
				},
				incomeReturn: {
					avgAnnualIncome: 0.0191,
					stdDev: 0.004
				}
			},
			{
				trailingYears: 40,
				totalReturn: {
					avgAnnualReturn: 0.1181,
					stdDev: 0.1652
				},
				incomeReturn: {
					avgAnnualIncome: 0.0258,
					stdDev: 0.011
				}
			}
		]
	},
    bonds: {
		name: 'Bonds',
        annualReturns: [
            {
                year: 1978,
                annualReturn: 1.40  
              },
              {
                 year: 1979,
                annualReturn:  1.90  
              },
              {
                 year: 1980,
                annualReturn:  2.70  
              },
              {
                 year: 1981,
                annualReturn:  6.30  
              },
              {
                 year: 1982,
                annualReturn:  32.60  
              },
              {
                 year: 1983,
                annualReturn:  8.40  
              },
              {
                 year: 1984,
                annualReturn:  15.15  
              },
              {
                 year: 1985,
                annualReturn:  22.11  
              },
              {
                 year: 1986,
                annualReturn:  15.26  
              },
              {
                 year: 1987,
                annualReturn:  2.76  
              },
              {
                 year: 1988,
                annualReturn:  7.89  
              },
              {
                 year: 1989,
                annualReturn:  14.53  
              },
              {
                 year: 1990,
                annualReturn:  8.96  
              },
              {
                 year: 1991,
                annualReturn:  16.00  
              },
              {
                 year: 1992,
                annualReturn:  7.40  
              },
              {
                 year: 1993,
                annualReturn:  9.75  
              },
              {
                 year: 1994,
                annualReturn:  -2.92  
              },
              {
                 year: 1995,
                annualReturn:  18.47  
              },
              {
                 year: 1996,
                annualReturn:  3.63  
              },
              {
                 year: 1997,
                annualReturn:  9.65  
              },
              {
                 year: 1998,
                annualReturn:  8.69  
              },
              {
                 year: 1999,
                annualReturn:  -0.82  
              },
              {
                 year: 2000,
                annualReturn:  11.63  
              },
              {
                 year: 2001,
                annualReturn:  8.44  
              },
              {
                 year: 2002,
                annualReturn:  10.26  
              },
              {
                 year: 2003,
                annualReturn:  4.10  
              },
              {
                 year: 2004,
                annualReturn:  4.34  
              },
              {
                 year: 2005,
                annualReturn:  2.43  
              },
              {
                 year: 2006,
                annualReturn:  4.33  
              },
              {
                 year: 2007,
                annualReturn:  6.97  
              },
              {
                 year: 2008,
                annualReturn:  5.24  
              },
              {
                 year: 2009,
                annualReturn:  5.93  
              },
              {
                 year: 2010,
                annualReturn:  6.54  
              },
              {
                 year: 2011,
                annualReturn:  7.84  
              },
              {
                 year: 2012,
                annualReturn:  4.21  
              },
              {
                 year: 2013,
                annualReturn:  -2.02  
              },
              {
                 year: 2014,
                annualReturn:  5.97  
              },
              {
                 year: 2015,
                annualReturn:  0.55  
              },
              {
                 year: 2016,
                annualReturn:  2.65  
              },
              {
                 year: 2017,
                annualReturn:  3.54  
              },
              {
                 year: 2018,
                annualReturn:  0.01  
              },
              {
                 year: 2019,
                annualReturn:  8.72  
              }
        ],
		historicalAverages: [
			{
				trailingYears: 1,
				totalReturn: {
					avgAnnualReturn: null,
					stdDev: null
				},
				incomeReturn: {
					avgAnnualIncome: 0.0296,
					stdDev: null
				}
			},
			{
				trailingYears: 5,
				totalReturn: {
					avgAnnualReturn: 0.0305,
					stdDev: 0.0347,
					sharpeRatio: 0.36
				},
				incomeReturn: {
					avgAnnualIncome: 0.0263,
					stdDev: null
				}
			},
			{
				trailingYears: 10,
				totalReturn: {
					avgAnnualReturn: 0.0375,
					stdDev: 0.0354,
					sharpeRatio: 0.46
				},
				incomeReturn: {
					avgAnnualIncome: 0.0279,
					stdDev: 0.0041
				}
			},
			{
				trailingYears: 20,
				totalReturn: {
					avgAnnualReturn: 0.0503,
					stdDev: 0.0343,
					sharpeRatio: 0.74
				},
				incomeReturn: {
					avgAnnualIncome: 0.0423,
					stdDev: 0.0178
				}
			},
			{
				trailingYears: 40,
				totalReturn: {
					avgAnnualReturn: 0.0751,
					stdDev: 0.0679
				},
				incomeReturn: {
					avgAnnualIncome: 0.0702,
					stdDev: 0.0342
				}
			}
		]
	},
	reits: {
		name: 'Publicly traded REITs',
        annualReturns: [
            {
                year: 1978,
                annualReturn: 10.34 
              },
              {
                year: 1979,
                annualReturn: 35.86
              },
              {
                year: 1980,
                annualReturn: 24.37 
              },
              {
                 year: 1981,
                 annualReturn: 6.00 
              },
              {
                year: 1982,
                annualReturn: 21.60 
              },
              {
                year: 1983,
                annualReturn: 30.64
              },
              {
                 year: 1984,
                 annualReturn: 20.93
              },
              {
                 year: 1985,
                 annualReturn: 19.10
              },
              {
                 year: 1986,
                 annualReturn: 19.16
              },
              {
                 year: 1987,
                annualReturn: -3.64
              },
              {
                 year: 1988,
                  annualReturn: 13.49
              },
              {
                 year: 1989,
                  annualReturn: 8.84 
              },
              {
                 year: 1990,
                  annualReturn: -15.35
              },
              {
                 year: 1991,
                annualReturn: 35.70
              },
              {
                 year: 1992,
                annualReturn: 14.59
              },
              {
                 year: 1993,
                annualReturn: 19.65
              },
              {
                 year: 1994,
                  annualReturn: 3.17
              },
              {
                 year: 1995,
                  annualReturn: 15.27
              },
              {
                 year: 1996,
                  annualReturn: 35.27
              },
              {
                 year: 1997,
                  annualReturn: 20.26
              },
              {
                 year: 1998,
                  annualReturn: -17.50
              },
              {
                 year: 1999,
                  annualReturn: -4.62
              },
              {
                 year: 2000,
                  annualReturn: 26.37
              },
              {
                 year: 2001,
                  annualReturn: 13.93
              },
              {
                 year: 2002,
                  annualReturn: 3.82
              },
              {
                 year: 2003,
                  annualReturn: 37.13
              },
              {
                 year: 2004,
                  annualReturn: 31.58 
              },
              {
                 year: 2005,
                  annualReturn: 12.16 
              },
              {
                 year: 2006,
                  annualReturn: 35.06
              },
              {
                 year: 2007,
                  annualReturn: -15.69
              },
              {
                 year: 2008,
                  annualReturn: -37.73
              },
              {
                 year: 2009,
                  annualReturn: 27.99 
              },
              {
                 year: 2010,
                  annualReturn: 27.96
              },
              {
                 year: 2011,
                  annualReturn: 8.29
              },
              {
                 year: 2012,
                 annualReturn: 18.06
              },
              {
                 year: 2013,
                annualReturn: 2.47
              },
              {
                 year: 2014,
                  annualReturn: 30.14
              },
              {
                 year: 2015,
                  annualReturn: 3.20
              },
              {
                 year: 2016,
                  annualReturn: 8.52
              },
              {
                 year: 2017,
                  annualReturn: 5.23
              },
              {
                 year: 2018,
                  annualReturn: -4.62
              },
              {
                 year: 2019,
                annualReturn: 26.00 
              }
        ],
		historicalAverages: [
			{
				trailingYears: 1,
				totalReturn: {
					avgAnnualReturn: null,
					stdDev: null
				},
				incomeReturn: {
					avgAnnualIncome: 0.0493,
					stdDev: null
				}
			},
			{
				trailingYears: 5,
				totalReturn: {
					avgAnnualReturn: 0.0721,
					stdDev: 0.1133,
					sharpeRatio: 0.48
				},
				incomeReturn: {
					avgAnnualIncome: 0.042,
					stdDev: null
				}
			},
			{
				trailingYears: 10,
				totalReturn: {
					avgAnnualReturn: 0.1194,
					stdDev: 0.1216,
					sharpeRatio: 0.81
				},
				incomeReturn: {
					avgAnnualIncome: 0.0428,
					stdDev: 0.0046
				}
			},
			{
				trailingYears: 20,
				totalReturn: {
					avgAnnualReturn: 0.1128,
					stdDev: 0.1868,
					sharpeRatio: 0.47
				},
				incomeReturn: {
					avgAnnualIncome: 0.054,
					stdDev: 0.0189
				}
			},
			{
				trailingYears: 40,
				totalReturn: {
					avgAnnualReturn: 0.1181,
					stdDev: 0.1671
				},
				incomeReturn: {
					avgAnnualIncome: 0.0729,
					stdDev: 0.0338
				}
			}
		]
	},
	pre: {
		name: 'Private real estate',
        annualReturns: [
            {
                year: 1978,
                annualReturn:  16.11  
              },
              {
                 year: 1979,
                annualReturn:  20.46 
              },
              {
                 year: 1980,
                annualReturn:  18.09  
              },
              {
                 year: 1981,
                annualReturn:  16.62  
              },
              {
                 year: 1982,
                annualReturn:  9.43  
              },
              {
                 year: 1983,
                annualReturn:  13.13  
              },
              {
                 year: 1984,
                annualReturn:  13.84 
              },
              {
                 year: 1985,
                annualReturn:  11.24
              },
              {
                 year: 1986,
                annualReturn:  8.30 
              },
              {
                 year: 1987,
                annualReturn:  8.00 
              },
              {
                 year: 1988,
                annualReturn:  9.62 
              },
              {
                 year: 1989,
                annualReturn:  7.77 
              },
              {
                 year: 1990,
                annualReturn:  2.30 
              },
              {
                 year: 1991,
                annualReturn:  -5.59 
              },
              {
                 year: 1992,
                annualReturn:  -4.26  
              },
              {
                 year: 1993,
                annualReturn:  1.38 
              },
              {
                 year: 1994,
                annualReturn:  6.39  
              },
              {
                 year: 1995,
                annualReturn:  7.54   
              },
              {
                 year: 1996,
                annualReturn:  10.31  
              },
              {
                 year: 1997,
                annualReturn:  13.91 
              },
              {
                 year: 1998,
                annualReturn:  16.24  
              },
              {
                 year: 1999,
                annualReturn:  11.36 
              },
              {
                 year: 2000,
                annualReturn:  12.24 
              },
              {
                 year: 2001,
                annualReturn:  7.28 
              },
              {
                 year: 2002,
                annualReturn:  6.74  
              },
              {
                 year: 2003,
                annualReturn:  8.99 
              },
              {
                 year: 2004,
                annualReturn:  14.48 
              },
              {
                 year: 2005,
                annualReturn:  20.06
              },
              {
                 year: 2006,
                annualReturn:  16.59
              },
              {
                 year: 2007,
                annualReturn:  15.84 
              },
              {
                 year: 2008,
                annualReturn:  -6.46 
              },
              {
                 year: 2009,
                annualReturn:  -16.86
              },
              {
                 year: 2010,
                annualReturn:  13.11 
              },
              {
                 year: 2011,
                annualReturn:  14.26
              },
              {
                 year: 2012,
                annualReturn:  10.54 
              },
              {
                 year: 2013,
                annualReturn:  10.99
              },
              {
                 year: 2014,
                annualReturn:  11.81
              },
              {
                 year: 2015,
                annualReturn:  13.33 
              },
              {
                 year: 2016,
                annualReturn:  7.97
              },
              {
                 year: 2017,
                annualReturn:  6.98
              },
              {
                 year: 2018,
                annualReturn:  6.71
              },
              {
                 year: 2019,
                annualReturn:  6.40
              }
        ],
        historicalAverages: [
			{
				trailingYears: 1,
				totalReturn: {
					avgAnnualReturn: null,
					stdDev: null
				},
				incomeReturn: {
					avgAnnualIncome: 0.044,
					stdDev: null
				}
			},
			{
				trailingYears: 5,
				totalReturn: {
					avgAnnualReturn: 0.0825,
					stdDev: 0.0288,
					sharpeRatio: 2.24
				},
				incomeReturn: {
					avgAnnualIncome: 0.0456,
					stdDev: null
				}
			},
			{
				trailingYears: 10,
				totalReturn: {
					avgAnnualReturn: 0.1017,
					stdDev: 0.0298,
					sharpeRatio: 2.71
				},
				incomeReturn: {
					avgAnnualIncome: 0.0517,
					stdDev: 0.0074
				}
			},
			{
				trailingYears: 20,
				totalReturn: {
					avgAnnualReturn: 0.0873,
					stdDev: 0.082,
					sharpeRatio: 0.76
				},
				incomeReturn: {
					avgAnnualIncome: 0.0605,
					stdDev: 0.0136
				}
			},
			{
				trailingYears: 40,
				totalReturn: {
					avgAnnualReturn: 0.0866,
					stdDev: 0.0725
				},
				incomeReturn: {
					avgAnnualIncome: 0.0687,
					stdDev: 0.0138
				}
			}
		]
	}
};
